import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ForgotPassword } from '../interfaces/forgot-password.interface';
import { ResetPassword } from '../interfaces/reset-password.inerface';
import { ChangePassword } from '../interfaces/change-password.interface';
import { AuthService } from './auth.service';
import { ServiceResponse } from '../models/serviceResponse.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  private baseUrl = environment.baseUrl + '/password';
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  forgotPassword(forgotPassword: ForgotPassword) {
    return this.http.post(this.baseUrl + '/forgotPassword', forgotPassword);
  }

  resetPassword(resetPassword: ResetPassword) {
    return this.http.post(this.baseUrl + '/resetPassword', resetPassword);
  }

  changePassword(changePassword: ChangePassword): Observable<ServiceResponse<any>> {
    // Get the current user's username from the auth service
    const userName = this.authService.getUserName();

    // Create the request object with all required fields
    const request = {
      userId: '', // This will be determined by the backend based on the token
      email: userName, // Using username as email
      currentPassword: changePassword.currentPassword,
      newPassword: changePassword.newPassword,
      confirmNewPassword: changePassword.confirmNewPassword
    };

    // Get the auth token
    const token = this.authService.getAuthBearerToken();
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);

    return this.http.post<ServiceResponse<any>>(
      this.baseUrl + '/changePassword',
      request,
      { headers: headers }
    );
  }
}
